/**
 * Homepage design inspiration — loads Creative Gallery designs (section home_limit).
 */
(function () {
  const Core = window.BraceletCore;
  const Cloud = window.DesignCloudApi;
  const PlazaRender = window.PlazaRender;
  if (!Core || !PlazaRender) return;

  const root = document.getElementById('design-inspiration');
  if (!root) return;

  const useApi = root.dataset.useApi === 'true' && Cloud?.enabled?.();
  if (!useApi) return;

  const limit = Math.max(1, parseInt(root.dataset.limit, 10) || 8);
  const detailBase = root.dataset.detailBase || '/pages/design-detail';
  const detailSep = root.dataset.detailSep || '?';

  const els = {
    track: root.querySelector('[data-di-track]'),
    empty: root.querySelector('[data-di-empty]'),
  };

  if (!els.track) return;

  const i18n = {
    view: root.dataset.i18nView || 'View design',
    community: root.dataset.i18nCommunity || 'Community',
  };

  async function init() {
    try {
      const { designs } = await Cloud.listPlaza({ page: 1, limit, sort: 'popular' });
      await PlazaRender.renderCards(els.track, designs, {
        detailBase,
        detailSep,
        viewLabel: i18n.view,
        communityLabel: i18n.community,
      });
      if (els.empty) els.empty.hidden = designs.length > 0;
    } catch (err) {
      console.warn('[Design Inspiration] Failed to load plaza designs', err);
      if (els.empty) els.empty.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
